import React from "react";

const WhyWeChoose = () => {
  return (
    <div className="container">
      <div className="why-choose-us-section">
        <h1>Why Choose Us</h1>
        <p>
          We are a global ISO certification provider dedicated to helping
          businesses meet international <br /> standards with ease and
          efficiency. With years of industry experience, we understand the
          challenges <br /> companies face and offer tailored solutions that
          ensure a smooth certification journey.
        </p>
        <p>
          Our team of skilled consultants, auditors, and trainers work closely
          with you to deliver results that go <br /> beyond certification. We
          focus on building trust, enhancing quality, and empowering your <br />{" "}
          organisation to thrive in a competitive, standards-driven world.
        </p>
        <button>Get Started</button>
      </div>


       <div className="about-middle-banner"></div>

       <div className="row about-certification-success">
        <div className="col-lg-5 about-certification-banner"></div>
        <div className="col-lg-6 about-certification-banner-content">
            <h1>Committed to Your Certification Success</h1>
            <h6>We help you achieve and maintain ISO certification, building  trust and credibility.</h6>
            <p>We guide you through every step to achieve ISO certification  quickly and confidently.</p>
            <p>Our expertise ensures a smooth, stress-free path to meeting and maintaining global standards, empowering your business to  grow with credibility and trust.</p>
            <p>We partner with businesses to make ISO certification simple,  efficient, and impactful. Our expert team provides tailored  guidance at every stage, ensuring you meet global standards with confidence.</p>
            <p>We turn complex certification processes into simple, achievable  milestones.</p>
        </div>
       </div>


    </div>
  );
};

export default WhyWeChoose;
